import { settingsCertificationEn } from './settings';

const pagesCertificationEn = {
  add: {
    form: {
      completed: {
        BASE: {
          message: 'Base Certification added.',
        },
        HANDLING: {
          message: 'Handling Certification added.',
        },
        SPECIALTY: {
          message: 'Specialty Certification added.',
        },
        completedBy: 'Completed by:',
        continueAdding: 'Continue adding another certification',
        goToBaseCertification: 'Go to base certification',
        goToCertification: 'Go to certification',
        goToHandlingCertification: 'Go to handling certification',
        goToList: 'Go to list',
        goToSpecialtyCertification: 'Go to specialty certification',
        message: 'Certification added.',
        result: 'Result',
      },
      fields: {
        baseCertificationAdministrativeAuthority: {
          issuingOrganizationId: {
            label: 'Issuing Organization ID',
            placeholder: 'Enter issuing organization ID',
          },
          regulatingAuthorityName: {
            label: 'Regulating Authority Name',
            placeholder: 'Enter regulating authority name',
          },
        },
        baseCertificationClassification: {
          certificationType: {
            label: 'Certification Type',
            options: {
              NATIONAL: 'National',
              PRIVATE: 'Private',
              PUBLIC: 'Public',
            },
            placeholder: 'Select certification type',
          },
          domain: {
            label: 'Domain',
            placeholder: 'Enter domain',
          },
          industryCategory: {
            label: 'Industry Category',
            options: {
              FINANCE: 'Finance',
              HEALTHCARE: 'Healthcare',
              INSURANCE: 'Insurance',
            },
            placeholder: 'Select industry category',
          },
        },
        baseCertificationIdInformation: {
          certificationCode: {
            label: 'Base Certification Code',
            placeholder: 'Enter base certification code',
          },
        },
        baseCertificationLawsAndRisks: {
          complianceRiskLevel: {
            label: 'Compliance Risk Level',
            options: {
              HIGH: 'High',
              LOW: 'Low',
              MEDIUM: 'Medium',
            },
            placeholder: 'Select compliance risk level',
          },
          legalBasis: {
            label: 'Legal Basis',
            placeholder: 'Enter legal basis',
          },
        },
        baseCertificationNameAndDisplay: {
          certificationName: {
            label: 'Certification Name',
            placeholder: 'Enter certification name',
          },
          certificationNameEn: {
            label: 'Certification Name (English)',
            placeholder: 'Enter certification name (English)',
          },
          certificationNameShort: {
            label: 'Certification Short Name',
            placeholder: 'Enter certification short name',
          },
          displayOrder: {
            label: 'Display Order',
            placeholder: 'Enter display order',
          },
        },
        baseCertificationOperationAndStatus: {
          archivedDate: {
            label: 'Archived Date',
            placeholder: 'Select archived date',
          },
          effectiveFrom: {
            label: 'Effective Start Date',
            placeholder: 'Select effective start date',
          },
          effectivePeriod: {
            checkboxLabel: 'Specify end date',
            label: 'Effective Period',
            placeholder: 'Select effective period',
          },
          effectiveTo: {
            label: 'Effective End Date',
            placeholder: 'Select effective end date',
          },
          remarks: {
            label: 'Remarks',
            placeholder: 'Enter remarks',
          },
        },
        baseCertificationSubjectInformation: {
          prerequisiteSummary: {
            label: 'Prerequisite Summary',
            placeholder: 'Enter prerequisite summary',
          },
          targetJobType: {
            label: 'Target Job Type',
            placeholder: 'Enter target job type',
          },
        },
        baseCertificationValidity: {
          defaultValidPeriodYears: {
            label: 'Default Valid Period (Years)',
            placeholder: 'Enter default valid period',
          },
          renewalDeadlineType: {
            label: 'Renewal Deadline Type',
            options: {
              EXPIRATION_DATE: 'Expiration date',
              YEAR_END: 'Year end',
            },
            placeholder: 'Select renewal deadline type',
          },
          renewalRequirementDescription: {
            label: 'Renewal Requirement Description',
            placeholder: 'Enter renewal requirement description',
          },
          renewalRequirementType: {
            label: 'Renewal Requirement Type',
            placeholder: 'Enter renewal requirement type',
          },
          renewalUnit: {
            label: 'Renewal Unit',
            options: {
              MONTH: 'Month',
              YEAR: 'Year',
            },
            placeholder: 'Select renewal unit',
          },
        },
        handlingCertificationIdInformation: {
          handlingCertificationCode: {
            label: 'Handling Certification Code',
            placeholder: 'Enter handling certification code',
          },
        },
        handlingIssuingOrganization: {
          issuingOrganizationId: {
            label: 'Issuing Organization ID',
            placeholder: 'Select issuing organization',
          },
        },
        handlingNameAndDisplay: {
          displayOrder: {
            label: 'Display Order',
            placeholder: 'Enter display order',
          },
          handlingName: {
            label: 'Handling Certification Name',
            placeholder: 'Enter handling certification name',
          },
          handlingNameEn: {
            label: 'Handling Certification Name (EN)',
            placeholder: 'Enter handling certification name in English',
          },
          shortName: {
            label: 'Short Name',
            placeholder: 'Enter short name',
          },
        },
        handlingOperationAndStatus: {
          archivedDate: {
            label: 'Archived Date',
            placeholder: 'Select archived date',
          },
          archivedFlag: {
            checkboxLabel: 'This certification is archived',
            label: 'Archived Flag',
          },
          effectiveFrom: {
            label: 'Effective Start Date',
            placeholder: 'Select effective start date',
          },
          effectivePeriod: {
            checkboxLabel: 'Specify end date',
            label: 'Effective Period',
            placeholder: 'Select effective period',
          },
          effectiveTo: {
            label: 'Effective End Date',
            placeholder: 'Select effective end date',
          },
          remarks: {
            label: 'Remarks',
            placeholder: 'Enter remarks',
          },
        },
        handlingRelatedBasicAndSpecialtyCertification: {
          baseCertificationIds: {
            add: 'Add Related Base Certification',
            label: 'Required Base Certification IDs',
            placeholder: 'Select base certifications',
          },
          specialtyCertificationIds: {
            add: 'Add Related Specialty Certification',
            label: 'Required Specialty Certification IDs',
            placeholder: 'Select specialty certifications',
          },
        },
        handlingRisksAndRestrictions: {
          handlerAttributeRestriction: {
            label: 'Handler Attribute Restriction',
            placeholder: 'Enter handler attribute restriction',
          },
          handlingRestriction: {
            label: 'Handling Restriction',
            placeholder: 'Enter handling restriction',
          },
        },
        handlingScope: {
          channel: {
            label: 'Channel',
            placeholder: 'Enter channel',
          },
          country: {
            label: 'Country',
            placeholder: 'Enter country',
          },
          organizationScope: {
            label: 'Organization Scope',
            placeholder: 'Enter organization scope',
          },
          region: {
            label: 'Region',
            placeholder: 'Enter region',
          },
        },
        handlingValidityAndRenewalRules: {
          defaultValidPeriodYears: {
            label: 'Default Valid Period (Years)',
            placeholder: 'Enter default valid period',
          },
          reCertificationRules: {
            label: 'Re-certification Rules',
            placeholder: 'Enter re-certification rules',
          },
          renewalRequirementDescription: {
            label: 'Renewal Requirement Description',
            placeholder: 'Enter renewal requirement description',
          },
        },
        specialtyCertificationIdInformation: {
          specialtyCertificationCode: {
            label: 'Specialty Certification Code',
            placeholder: 'Enter specialty certification code',
          },
        },
        specialtyClassificationAndLevel: {
          specialtyCategory: {
            label: 'Specialty Category',
            placeholder: 'Enter specialty category',
          },
          specialtyDescription: {
            label: 'Specialty Description',
            placeholder: 'Enter specialty description',
          },
          specialtyLevel: {
            label: 'Specialty Level',
            placeholder: 'Enter specialty level',
          },
        },
        specialtyIssuingOrganization: {
          issuingOrganizationId: {
            label: 'Issuing Organization ID',
            placeholder: 'Enter issuing organization ID',
          },
        },
        specialtyNameAndDisplay: {
          displayOrder: {
            label: 'Display Order',
            placeholder: 'Enter display order',
          },
          specialtyName: {
            label: 'Specialty Name',
            placeholder: 'Enter specialty name',
          },
          specialtyNameEn: {
            label: 'Specialty Name (EN)',
            placeholder: 'Enter specialty name in English',
          },
          specialtyNameShort: {
            label: 'Short Name',
            placeholder: 'Enter short name',
          },
        },
        specialtyOperationAndStatus: {
          archivedDate: {
            label: 'Archived Date',
            placeholder: 'Select archived date',
          },
          archivedFlag: {
            checkboxLabel: 'This certification is archived',
            label: 'Archived Flag',
          },
          effectiveFrom: {
            label: 'Effective Start Date',
            placeholder: 'Select effective start date',
          },
          effectivePeriod: {
            checkboxLabel: 'Specify end date',
            label: 'Effective Period',
            placeholder: 'Select effective period',
          },
          effectiveTo: {
            label: 'Effective End Date',
            placeholder: 'Select effective end date',
          },
          remarks: {
            label: 'Remarks',
            placeholder: 'Enter remarks',
          },
        },
        specialtyPrerequisites: {
          requiredCaseCount: {
            label: 'Required Case Count',
            placeholder: 'Enter required case count',
          },
          requiredExperienceYears: {
            label: 'Required Experience Years',
            placeholder: 'Enter required experience years',
          },
          requiredOtherCertification: {
            add: 'Add Required Other Certification',
            label: 'Required Other Certification',
            placeholder: 'Enter required other certification',
          },
        },
        specialtyRelatedBasicCertification: {
          baseCertificationIds: {
            add: 'Add Related Base Certification',
            label: 'Base Certification ID',
            placeholder: 'Enter base certification ID',
          },
          requiredBaseCertificationLevelStatus: {
            label: 'Required Base Certification Level/Status',
            placeholder: 'Enter required base certification level/status',
          },
        },
        specialtyScope: {
          country: {
            label: 'Country',
            placeholder: 'Enter country',
          },
          region: {
            label: 'Region',
            placeholder: 'Enter region',
          },
          restrictedOrganizationFlag: {
            checkboxLabel: 'Restricted to specific organizations',
            label: 'Restricted Organization Flag',
          },
        },
        specialtyValidityAndRenewalRules: {
          defaultValidPeriodYears: {
            label: 'Default Valid Period (Years)',
            placeholder: 'Enter default valid period',
          },
          reacquisitionRule: {
            label: 'Reacquisition Rule',
            placeholder: 'Enter reacquisition rule',
          },
          renewalRequirementDescription: {
            label: 'Renewal Requirement Description',
            placeholder: 'Enter renewal requirement description',
          },
          renewalRequirementType: {
            label: 'Renewal Requirement Type',
            placeholder: 'Enter renewal requirement type',
          },
          renewalUnit: {
            label: 'Renewal Unit',
            placeholder: 'Select renewal unit',
          },
        },
      },
      navigation: {
        steps: {
          baseCertificationAdministrativeAuthority: {
            title: 'Administrative Authority',
          },
          baseCertificationClassification: {
            title: 'Certification Classification',
          },
          baseCertificationIdInformation: {
            title: 'Certification ID Information',
          },
          baseCertificationLawsAndRisks: {
            title: 'Laws and Risks',
          },
          baseCertificationNameAndDisplay: {
            title: 'Certification Name and Display',
          },
          baseCertificationOperationAndStatus: {
            title: 'Operation and Status',
          },
          baseCertificationSubjectInformation: {
            title: 'Subject Information',
          },
          baseCertificationValidity: {
            title: 'Validity and Renewal',
          },
          cards: {
            idInformation: {
              certificationHolder: 'Certification Holder',
              certificationHolderPlaceholder: 'Select Certification Holder',
              certificationId: 'Certification ID',
              certificationName: 'Certification Name',
              certificationParty: 'Certification Party',
              title: 'Certification ID Information',
            },
            validityPeriod: {
              effectiveDate: 'Effective Date',
              expirationDate: 'Expiration Date (Optional)',
              renewalDate: 'Renewal Date (Optional)',
              title: 'Validity Period',
            },
          },
          certificationInformation: {
            title: 'Certification information',
          },
          common: {
            submitButtonLabel: 'Add Certification',
          },
          handlingCertificationIdInformation: {
            title: 'Handling ID Information',
          },
          handlingIssuingOrganization: {
            title: 'Issuing Organization',
          },
          handlingNameAndDisplay: {
            title: 'Name and Display',
          },
          handlingOperationAndStatus: {
            title: 'Operation and Status',
          },
          handlingRelatedBasicAndSpecialtyCertification: {
            title: 'Related Basic and Specialty Certification',
          },
          handlingRisksAndRestrictions: {
            title: 'Risks and Restrictions',
          },
          handlingScope: {
            title: 'Scope',
          },
          handlingValidityAndRenewalRules: {
            title: 'Validity and Renewal Rules',
          },
          specialtyCertificationIdInformation: {
            title: 'Specialty Certification ID Information',
          },
          specialtyClassificationAndLevel: {
            title: 'Classification and Level',
          },
          specialtyIssuingOrganization: {
            title: 'Issuing Organization',
          },
          specialtyNameAndDisplay: {
            title: 'Name and Display',
          },
          specialtyOperationAndStatus: {
            title: 'Operation and Status',
          },
          specialtyPrerequisites: {
            title: 'Prerequisites',
          },
          specialtyRelatedBasicCertification: {
            title: 'Related Basic Certification',
          },
          specialtyScope: {
            title: 'Scope',
          },
          specialtyValidityAndRenewalRules: {
            title: 'Validity and Renewal Rules',
          },
        },
        title: 'Add certification',
      },
      progressbar: {
        filled: 'filled',
        left: '{{value}} left',
        modeSetting: 'Mode Settings',
        mustItem: 'Must Item',
        mustItemOnly: 'Must item only',
        total: 'Total',
      },
    },
    intro: {
      body: {
        fillOutDetails: 'Fill out the details',
        itemCard: {
          requiredDetails: 'Required details:',
        },
        selectCertification: 'Select the certification:',
      },
      header: {
        headerTitle: 'Add Certification Data to your Registry',
      },
      options: {
        addCertificationHolder: 'Add person certification data',
        description: 'Or you might want to...',
      },
    },
  },
  certificationHolder: {
    list: {
      addCertificationHolder: 'Add certification holder',
      filterPlaceholder: 'Search by name or number...',
      pageTitle: 'Certification Holders',
    },
  },
  certificationHolderStatus: {
    ACTIVE: 'Active',
    APPLYING: 'Applying',
    EXPIRED: 'Expired',
    REVOKED: 'Revoked',
    SUSPENDED: 'Suspended',
  },
  certificationKind: {
    base: 'Base certification',
    handling: 'Handling certification',
    specialty: 'Specialty certification',
  },
  certificationStatus: {
    ARCHIVED: 'Archived',
    EFFECTIVE: 'Effective',
    NOT_EFFECTIVE_YET: 'Not Effective Yet',
  },
  detail: {
    body: {
      errors: {
        certificationIdLabel: 'Certification ID: {{id}}',
        certificationNotFound: 'Certification details not found',
        dataLoadFailed: 'Failed to load data',
        unknownError: 'An unknown error occurred',
      },
      noDataMessage: 'No data available in this section.',
    },
    tabs: {
      certificationHolders: 'People',
      detail: 'Detail',
      handlingCertifications: 'Handling certifications',
      specialtyCertifications: 'Specialty certifications',
    },
  },
  errors: {
    loadingFailed: 'Failed to load data',
    unknownError: 'An unknown error occurred',
  },
  handling: {
    detail: {
      body: {
        errors: {
          dataLoadFailed: 'Failed to load data',
          handlingCertificationIdLabel: 'Handling Certification ID: {{id}}',
          handlingCertificationNotFound:
            'Handling certification details not found',
          unknownError: 'An unknown error occurred',
        },
        noDataMessage: 'No data available in this section.',
      },
      tabs: {
        certificationHolders: 'Certification Holders',
        detail: 'Detail',
      },
    },
    list: {
      addHandlingCertification: 'Add Handling Certification',
      filterPlaceholder: 'Search by handling certification name...',
      pageTitle: 'Handling Certifications',
      tabs: {
        archived: 'Archived',
        effective: 'Effective',
        notEffective: 'Not Effective',
      },
    },
  },
  list: {
    actions: {
      export: 'Export',
      share: 'Share',
    },
    addCertification: 'Add Certification',
    filterPlaceholder: 'Search by certification name...',
    pageTitle: 'Certifications',
    tabs: {
      all: 'All',
      archived: 'Archived',
    },
  },
  peopleTab: {
    list: {
      addCertificationHolder: 'Add certification holder',
      filterPlaceholder: 'Search by person name or certification name...',
      pageTitle: 'User',
    },
  },
  settings: settingsCertificationEn,
  specialty: {
    detail: {
      body: {
        errors: {
          dataLoadFailed: 'Failed to load data',
          specialtyCertificationIdLabel: 'Specialty Certification ID: {{id}}',
          specialtyCertificationNotFound:
            'Specialty certification details not found',
          unknownError: 'An unknown error occurred',
        },
        noDataMessage: 'No data available in this section.',
      },
      tabs: {
        certificationHolders: 'Certification Holders',
        detail: 'Detail',
        handlingCertifications: 'Handling Certifications',
      },
    },
    list: {
      addSpecialtyCertification: 'Add Specialty Certification',
      filterPlaceholder: 'Search by specialty certification name...',
      pageTitle: 'Specialty Certifications',
    },
  },
  tabs: {
    detail: 'Detail',
  },
  validation: {
    required: '{{field}} is required',
  },
};

export default pagesCertificationEn;
